/**
 * Ajuda dos campos do repositorio de documentos.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 *
 * O painel de documentos aparece em varias telas (tomador, operacao, corretor,
 * apolice, endosso, segurado), cada uma de outro modulo. A ajuda dele fica aqui, uma
 * vez, em `ajudaDoRepositorio`, e o painel a passa ao campo; a tela /documentos usa a
 * mesma pelo dicionario.
 */
export const ajudaDoRepositorio = {
  'Nomear documento':
    'Nome que aparece na lista. Vazio, o documento leva o nome do arquivo, sem a extensao.',
  'Comentario do envio':
    'Observacao de quem envia, guardada com a versao do arquivo. Aparece no historico de versoes.',
  'Tipo de documento':
    'Tipo do catalogo da empresa, cadastrado em Documentos. So marca o documento: nenhuma regra exige documento pelo tipo.',
  'Descricao da situacao':
    'O que falta, o que foi pedido de novo ou por que foi dispensado. Texto de acompanhamento, sem efeito na esteira.',
  Validade:
    'Data informada por quem recebeu o documento. Depois dela o documento aparece como vencido; nada e bloqueado por isso.',
} as const;

export const ajuda: Record<string, Record<string, string>> = {
  '/documentos': {
    ...ajudaDoRepositorio,
    'Nome do tipo':
      'Nome unico na empresa, sem diferenca de maiusculas. O tipo nao e excluido, so desativado, e o documento antigo continua com ele.',
    'Descricao do tipo':
      'Explica quando o tipo se aplica, para quem escolhe o tipo ao exigir ou enviar um documento.',
  },
};
